import React from "react"

const ButtonLoading = ({text, className, type, isProcessing, onClick}) => (
  <button className={className} type={type} disabled={isProcessing} onClick={onClick}>
    {isProcessing && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
    {text}
  </button>
)

export default ButtonLoading

